module.exports = __webpack_public_path__ + "img/Artboard 5.ad777ec4.png";